import { type FC } from "react";
import { InformationPage } from "~/common/components/informationPage/InformationPage";
import { MAIL_SENT } from "~/utils/url/staticResources";

import { WISHLIST_PAGE } from "~/utils/url/staticUrls";
import { Button } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface Props {
  wishlistName: string;
  imageSrc?: string;
}

export const ShareWishlistConfirmationPage: FC<Props> = ({ wishlistName, imageSrc = MAIL_SENT }) => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>{t("page.shareWishlistConfirmation.title", { wishlistName })}</InformationPage.Title>
      <InformationPage.Image src={imageSrc} />
      <Button href={WISHLIST_PAGE}>{t("share.wishlist.confirmation.back.btn")}</Button>
    </InformationPage.CenterContents>
  );
};

export interface ShareWishlistConfirmationPageProps {
  wishlistName: string;
}

export function createShareWishlistConfirmationPage(props: ShareWishlistConfirmationPageProps) {
  return <ShareWishlistConfirmationPage wishlistName={props.wishlistName} />;
}
